// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"7043a770","453":"ed3810f9","608":"75cd107f","698":"3dbe0b82","771":"f55b50b5","786":"d9c679bb","966":"caf1ea33"}[chunkId] + ".chunk.js";
};